
import Vue, { PropType } from "vue";

export default Vue.extend({
  name: "TimeList",
  props: {
    headers: {
      type: Array as PropType<{ text: string; value: string }[]>,
      required: true
    },
    items: {
      type: Object as PropType<any>,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    dense: {
      type: Boolean,
      required: false,
      default: false
    }
  }
});
